import { useParallax } from "hooks/useParallax";
import Reveal from "./Reveal";

interface ParallaxBandProps {
  src: string;
  alt: string;
}

const ParallaxBand = ({ src, alt }: ParallaxBandProps) => {
  const { ref, offset } = useParallax<HTMLDivElement>(0.12);

  return (
    <Reveal className="mx-auto mb-20 w-full max-w-5xl">
      <div className="relative h-[380px] w-full overflow-hidden rounded-3xl ring-1 ring-white/10 max-sm:h-[220px]">
        <div
          ref={ref}
          className="absolute -inset-y-16 inset-x-0"
          style={{ transform: `translateY(${offset}px)` }}
        >
          <img src={src} alt={alt} className="h-full w-full object-cover" />
        </div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/10" />
      </div>
    </Reveal>
  );
};

export default ParallaxBand;
